/*
 * NutriProVita product page — the three behaviours that aren't Sense's:
 *   1. gallery: thumbnail select + CSS hover-zoom (design has no <media-gallery>)
 *   2. variant -> image sync (via Sense's `variant:change` pub/sub)
 *   3. "Add to cart — £X" running total on qty / variant change
 *   4. accordion panels default open (Description already has [open])
 *
 * Sense's product-info.js / product-form.js / <variant-selects> / <quantity-input>
 * do all the real work (variant match, price/availability swap, add to cart).
 */
(function () {
  function initGallery(root) {
    var stage = root.querySelector('[data-npv-zoom]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.npv-pdp__thumb'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('.npv-pdp__slide'));
    if (!stage) return;

    function show(index) {
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (t, i) {
        var on = i === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        show(i);
      });
    });

    // hover-zoom (ProductPage.tsx:167) — desktop pointer only
    stage.addEventListener('click', function () {
      stage.classList.toggle('is-zoomed');
    });
    stage.addEventListener('mousemove', function (e) {
      if (!stage.classList.contains('is-zoomed')) return;
      var rect = stage.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      var img = stage.querySelector('.npv-pdp__slide.is-active .npv-pdp__stage-img');
      if (img) img.style.transformOrigin = x + '% ' + y + '%';
    });
    stage.addEventListener('mouseleave', function () {
      stage.classList.remove('is-zoomed');
    });

    // variant -> image: activate the thumb for the variant's featured media
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
        var mediaId = event && event.data && event.data.variant && event.data.variant.featured_media
          ? String(event.data.variant.featured_media.id)
          : null;
        if (!mediaId) return;
        var idx = thumbs.findIndex(function (t) {
          return t.getAttribute('data-media-id') === mediaId;
        });
        if (idx > -1) show(idx);
      });
    }
  }

  function initRunningTotal(root) {
    var totalEl = root.querySelector('[data-npv-total]');
    var qtyInput = root.querySelector('.quantity__input');
    var priceEl = root.querySelector('#price-' + (root.dataset.section || ''));
    if (!totalEl || !qtyInput || !priceEl) return;

    function unitPrice() {
      // Sense's price.liquid emits several .price-item nodes (regular / sale /
      // compare-at), some empty, shown/hidden by CSS. Just take the first
      // currency amount in the visible text — "£18.99", "18,99 kr", "$18.99".
      var text = priceEl.textContent || '';
      var m = text.match(/(\d[\d.,]*\d|\d)/);
      if (!m) return NaN;
      var raw = m[0];
      // Normalise: if there's both "," and "." assume "," is thousands; if only
      // "," and it looks like decimals (two trailing digits) treat it as the point.
      if (raw.indexOf('.') > -1) {
        raw = raw.replace(/,/g, '');
      } else if (/,\d{2}$/.test(raw)) {
        raw = raw.replace(/\./g, '').replace(',', '.');
      } else {
        raw = raw.replace(/,/g, '');
      }
      return parseFloat(raw);
    }

    function update() {
      var qty = parseInt(qtyInput.value, 10) || 1;
      var unit = unitPrice();
      if (isNaN(unit)) {
        totalEl.textContent = '';
        return;
      }
      var total = (unit * qty).toFixed(2);
      totalEl.textContent = ' — £' + total;
    }

    qtyInput.addEventListener('change', update);
    qtyInput.addEventListener('input', update);
    // price node is re-rendered on variant change; re-read after
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(update, 60);
      });
    }
    // observe the price element for Sense's innerHTML swap
    new MutationObserver(update).observe(priceEl, { childList: true, subtree: true });
    update();
  }

  function init() {
    var root = document.querySelector('.npv-pdp');
    if (!root) return;
    initGallery(root);
    initRunningTotal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
